export default __webpack_public_path__ + "static/media/construction.30c439dc.png";